/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankIdentifierValidationType {
    NONE = 'NONE',
    IBAN = 'IBAN',
    BIC = 'BIC',
    ABA_ROUTING = 'ABA_ROUTING',
    CA_ROUTING = 'CA_ROUTING',
    SORT_CODE = 'SORT_CODE',
}
